import { render, staticRenderFns } from "./StaffGrid.vue?vue&type=template&id=1c96b440"
import script from "./StaffGrid.vue?vue&type=script&lang=js"
export * from "./StaffGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports